import { defineAsyncComponent } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue.js?vue3';
import { initHandRaiseLead } from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/hand_raise_leads/hand_raise_lead/index.js?vue3';
import EndOfTrialModal from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/end_of_trial/components/end_of_trial_modal.vue?vue3';
import { initSimpleApp } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/helpers/init_simple_app_helper.js?vue3';

initHandRaiseLead();
initSimpleApp('#js-end-of-trial-modal', EndOfTrialModal, { withApolloProvider: true });
initSimpleApp(
  '#js-amazon-q-settings',
  // A bare `() => import(...)` factory is the Vue 2 async-component syntax;
  // plain Vue 3 treats it as a functional component and renders the returned
  // promise as literal "[object Promise]" text.
  defineAsyncComponent(
    () =>
      import(
        /* webpackChunkName: 'amazonQGroupSettings' */ '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/amazon_q_settings/components/group_settings_app.vue?vue3'
      ),
  ),
);
